import request from '@/utils/request';

const downloadFileRequest = id =>
  request.get(`/templateimage/file/${id}`, {
    responseType: 'blob'
  });

const deleteFileRequest = id => request.delete(`/templateimage/file/${id}`);

export const storeExtensions = {
  actions: {
    downloadFile({ dispatch }, id) {
      return downloadFileRequest(id);
    },
    deleteFile({ dispatch }, id) {
      return deleteFileRequest(id);
    }
  }
};
